import { api } from "./api";

export const userContacts = api.injectEndpoints({
  endpoints: builder => ({
    getContacts: builder.query({
      query: () => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/`,

        }
      },
      keepUnusedDataFor: 5,
    }),
    updateContact: builder.mutation({
      query: ({
        email,
        first_name,
        id,
        last_name,
        phone_number,
        relationship,
        type,
        username,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/${id}/`,
          method: 'PATCH',
          body: {
            email,
            first_name,
            last_name,
            phone_number,
            relationship,
            type,
            username,
          },
        }
      },
    }),
    createContact: builder.mutation({
      query: ({
        email,
        first_name,
        last_name,
        phone_number,
        relationship,
        type,
        username,
      }) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/`,
          method: 'POST',
          body: {
            email,
            first_name,
            last_name,
            phone_number,
            relationship,
            type,
            username,
          },
        }
      },
    }),
    deleteContact: builder.mutation({
      query: (id) => {
        return {
          url: `${process.env.REACT_APP_API_URL}/users/profile/contacts/${id}/`,
          method: 'DELETE',
        }
      },
    }),
  })
});

export const {
  useGetContactsQuery,
  useUpdateContactMutation,
  useCreateContactMutation,
  useDeleteContactMutation,
} = userContacts;
